import { render, staticRenderFns } from "./nearby-point.vue?vue&type=template&id=1b9ff168&scoped=true&"
import script from "./nearby-point.vue?vue&type=script&lang=js&"
export * from "./nearby-point.vue?vue&type=script&lang=js&"
import style0 from "./nearby-point.vue?vue&type=style&index=0&id=1b9ff168&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9ff168",
  null
  
)

export default component.exports